var map = {
	"./ar": 93095,
	"./ar.ts": 93095,
	"./bn": 83327,
	"./bn.ts": 83327,
	"./en": 82070,
	"./en.ts": 82070,
	"./fa": 72931,
	"./fa.ts": 72931,
	"./fr": 35628,
	"./fr.ts": 35628,
	"./id": 29045,
	"./id.ts": 29045,
	"./it": 12731,
	"./it.ts": 12731,
	"./ms": 87610,
	"./ms.ts": 87610,
	"./nl": 66674,
	"./nl.ts": 66674,
	"./pt": 87177,
	"./pt.ts": 87177,
	"./ru": 45718,
	"./ru.ts": 45718,
	"./sq": 47918,
	"./sq.ts": 47918,
	"./th": 18818,
	"./th.ts": 18818,
	"./tr": 73331,
	"./tr.ts": 73331,
	"./ur": 6832,
	"./ur.ts": 6832,
	"./zh": 77027,
	"./zh.ts": 77027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70301;